/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {
  Card,
  CardContent,
  Box,
  Typography,
  Stack,
  Divider,
} from '@mui/material';
import CardAvatar from 'atoms/CardAvatar/CardAvatar';
import { StyledCardHeader } from '../InvoiceChart/InvoiceChart.styles';

interface SummaryStatsBarProps {
  totalAccounts: number;
  actualCost: number;
  potentialCost: number;
  savingsPercentage: number;
}

const CompanyOverviewBlock: React.FC<SummaryStatsBarProps> = ({
  totalAccounts,
  actualCost,
  potentialCost,
  savingsPercentage,
}) => (
  <Card>
    <StyledCardHeader title="Overview Summary" avatar={<CardAvatar />} />
    <CardContent>
      <Box sx={{ p: 2 }}>
        <Stack
          direction="row"
          spacing={2}
          divider={<Divider orientation="vertical" flexItem />}
          alignItems="center"
          justifyContent="space-between"
        >
          {/* Total Accounts */}
          <Box textAlign="center" minWidth={120}>
            <Typography variant="h5" fontWeight={600} color="#2F80ED">
              {totalAccounts}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              TOTAL ACCOUNTS
            </Typography>
          </Box>

          {/* Actual Cost */}
          <Box textAlign="center" minWidth={120}>
            <Typography variant="h5" fontWeight={600} color="#D32F2F">
              ${actualCost.toFixed(2)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ACTUAL COST
            </Typography>
          </Box>

          {/* Potential Cost */}
          <Box textAlign="center" minWidth={120}>
            <Typography variant="h5" fontWeight={600} color="#27AE60">
              ${potentialCost.toFixed(2)}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              POTENTIAL COST
            </Typography>
          </Box>

          {/* Savings Percentage */}
          <Box textAlign="center" minWidth={120}>
            <Typography variant="h5" fontWeight={600} color="#27AE60">
              {savingsPercentage.toFixed(2)}%
            </Typography>
            <Typography variant="caption" color="text.secondary">
              SAVINGS PERCENTAGE
            </Typography>
          </Box>
        </Stack>
      </Box>
    </CardContent>
  </Card>
);

export default CompanyOverviewBlock;
